import { PageLayout } from '~/components/PageLayout/PageLayout';
import { withPrivateRoute } from '~/hocs/withPrivateRoute';
import { Schema } from './components/referee-form.schema';
import { RefereeForm } from './components/referee-form';
import { useCreateRefereeMutation } from '../mutation';
import { Fragment } from 'react/jsx-runtime';
import { useNavigate } from 'react-router';
import { JudgeWrite } from '~/apis/ssf';

export const Page = withPrivateRoute(() => {
  const mutation = useCreateRefereeMutation();
  const navigate = useNavigate();

  async function handleSubmit(payload: Schema) {
    return await mutation.mutateAsync({
      ...payload,
      person: payload.person[1],
    });
  }

  function handleSuccess({ id }: JudgeWrite) {
    navigate(`../${id}/licenses/create`);
  }

  return (
    <Fragment>
      <PageLayout.Heading text="Skapa domare" />

      <PageLayout.Section>
        <RefereeForm onSubmit={handleSubmit} onSuccess={handleSuccess} mode="create" />
      </PageLayout.Section>
    </Fragment>
  );
});
